import { createAction, props } from '@ngrx/store';
import {
  NewCustomerDTO,
  TokenResponse,
  ResetResponse,
  ICustomerUser
} from '@care-portals/api-interfaces';

export const validateAuth = createAction('[Auth] Validate Auth');

export const unauthenticatedState = createAction(
  '[Auth] Unauthenticated State'
);

export const logIn = createAction(
  '[Auth] Login',
  props<{ username: string; password: string }>()
);

export const logInSuccess = createAction(
  '[Auth] Login Success',
  props<{ token: string; email?: string }>()
);

export const logInFailure = createAction(
  '[Auth] Login Failure',
  props<{ username?: string; error: Error }>()
);

export const loadUser = createAction(
  '[Auth] Load User',
  props<{ token: string }>()
);

export const loadUserSuccess = createAction(
  '[Auth] Load User Success',
  props<{ payload: ICustomerUser }>()
);

export const loadUserFailure = createAction(
  '[Auth] Loud User Failure',
  props<{ error: Error }>()
);

export const signUp = createAction(
  '[Auth] Sign Up',
  props<{ newCustomerDTO: NewCustomerDTO }>()
);

export const signUpSuccess = createAction(
  '[Auth] Sign Up Success',
  props<{ newCustomerDTO: NewCustomerDTO }>()
);

export const signUpFailure = createAction(
  '[Auth] Sign Up Failure',
  props<{ error: Error }>()
);

export const logOut = createAction('[Auth] LogOut');

export const logOutSuccess = createAction('[Auth] LogOut Success');

export const forgotPassword = createAction(
  '[Auth] Request Forgot Password',
  props<{ username: string }>()
);

export const forgotPasswordSuccess = createAction(
  '[Auth] Forgot Password Success',
  props<ResetResponse>()
);

export const forgotPasswordFailure = createAction(
  '[Auth] Forgot Password Failure',
  props<{ error: Error }>()
);

export const validPasswordToken = createAction(
  '[Auth] Request Validate Password Token',
  props<{ token: string }>()
);

export const validPasswordTokenSuccess = createAction(
  '[Auth] Validate Password Token Success'
);

export const validPasswordTokenFailure = createAction(
  '[Auth] Validate Password Token Failure',
  props<{ error: Error }>()
);

export const resetPassword = createAction(
  '[Auth] Request Reset Password',
  props<{ token: string; password: string }>()
);

export const resetPasswordSuccess = createAction(
  '[Auth] Reset Password Success',
  props<{ username: string; password: string }>()
);

export const resetPasswordFailure = createAction(
  '[Auth] Reset Password Failure',
  props<{ error: Error }>()
);

export const navigateToRedirectLink = createAction(
  '[Auth] Navigate To Redirect Link'
);

export const loginWithVerifyLink = createAction(
  '[Auth] Login + Verify Email',
  props<{ verifyToken: string }>()
);

export const loginWithVerifyLinkSuccess = createAction(
  '[Auth] Login + Verify Email Success',
  props<{ accessToken: TokenResponse }>()
);

export const loginWithVerifyLinkFailure = createAction(
  '[Auth] Login + Verify Email Failure',
  props<{ error: Error }>()
);
